import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('ExpiredPasswordPanelApp => ');

const updateField = createAction('update form value', (fieldId, value) => ({ fieldId, value }));

const onExpiredPasswordPanelRequest = createAction('expired request', formRef => ({ formRef }));
const onExpiredPasswordPanelSuccess = createAction('expired success');
const onExpiredPasswordPanelFailure = createAction('expired failure');

export default {
  onExpiredPasswordPanelRequest,
  onExpiredPasswordPanelSuccess,
  onExpiredPasswordPanelFailure,

  updateField,
};
